(function($, undef) {
    $.fn.xval = function() {
        var self = this;
        var value = arguments[0];
        var silent = arguments[1];
        if (this.is("select")) {
            var select = this.get(0);
            if (select.multiple) {
                if (arguments.length) {
                    var values = (value instanceof Array) ? value : [value];
                    for (var i in values) values[i] = values[i].toString();
                    var changed = false;
                    for (var i = 0; i < select.options.length; i ++) {
                        var option = select.options[i];
                        var oldVal = option.selected,
                            newVal = (values.indexOf(option.value) != -1);
                        if (newVal !== oldVal) {
                            option.selected = newVal;
                            changed = true;
                        }
                    }
                    if (!silent && changed) this.trigger('change');
                    return this;
                }
                var selected = [];
                for (var i = 0; i < select.options.length; i ++) {
                    var option = select.options[i];
                    if (option.selected) selected.push(option.value);
                }
                return selected;
            } else {
                if (arguments.length) {
                    var oldVal = select.options[select.selectedIndex].value,
                        newVal = value.toString(),
                        changed = false;
                    if (newVal !== oldVal) {
                        for (var i = 0; i < select.options.length; i ++) {
                            var option = select.options[i];
                            if (option.value === newVal) {
                                select.selectedIndex = i;
                                changed = true;
                                break;
                            }
                        }
                    }
                    if (!silent && changed) this.trigger('change');
                    return this;
                }
                return this.val();
            }
        } else if (this.is("input:radio")) {
            var firstInput = this.get(0);
            if (arguments.length) {
                for (var i = 0; i < this.length; i ++) {
                    var input = this.get(i);
                    var oldVal = input.checked,
                        newVal = (input.value === value.toString());
                    if (newVal != oldVal) {
                        input.checked = newVal;
                        if (!silent) $(input).trigger('change');
                    }
                }
                return this;
            }
            return this.filter(":checked").val();
        } else if (this.is("input:checkbox")) {
            var firstInput = this.get(0);
            if (arguments.length) {
                var values = (value instanceof Array) ? value : [value];
                for (var i in values) values[i] = values[i].toString();
                for (var i = 0; i < this.length; i ++) {
                    var input = this.get(i);
                    var oldVal = input.checked,
                        newVal = (values.indexOf(input.value.toString()) != -1);
                    if (newVal != oldVal) {
                        input.checked = newVal;
                        if (!silent) $(input).trigger('change');
                    }
                }
                return this;
            }
            var checked = [];
            for (var i = 0; i < this.length; i ++) {
                var input = this.get(i);
                if (input.checked) checked.push(input.value);
            }
            return checked;
        } else {
            if (arguments.length) {
                var input = this.get(0);
                var oldVal = input.value,
                    newVal = value.toString();
                if (oldVal !== newVal) {
                    input.value = newVal;
                    if (!silent) this.trigger('change');
                }
                return this;
            }
            return this.val();
        }
    }
})(jQuery);
